/**
 * 自定义扩展插件工具
 * 工具集合 MD5、Base64、二维码、设备类型
 */
'use strict'

import 'es6-promise/auto';
//MD5加密
import JSMD5 from 'js-md5';
//QRCode二维码生成
import QRCode from 'qrcode';
//JSBase64
import JSBase64 from 'js-base64';

var plugins = function(){};

/**
 * 对Date的扩展，将 Date 日期格式化为指定格式的 String 字符串
 * 年(y)、月(M)、日(d)、季度(q)、小时(h)、分(i)、秒(s)、毫秒(f)
 * 年(y)为1-4个占位符，毫秒(f)为1个占位符，其他为1-2个占位符。
 * 例子：
 * (new Date()).Format("yyyy-MM-dd hh:ii:ss.f") ==> 2006-07-02 08:09:04.423 
 * (new Date()).Format("yyyy-M-d h:i:s.f")      ==> 2006-7-2 8:9:4.18
 * 
 * console.log("Date.format(fmt):",(new Date).format());
 */
plugins.dateFormat = function (date, fmt) {
  var t = date;
  if (typeof(t)=="number") { t = new Date( date * ((date+"").length==10 ? 1000 : 1) ); }
  fmt = fmt || "yyyy-MM-dd hh:ii:ss:f";
  var o = {
      "M+": t.getMonth() + 1, 
      "d+": t.getDate(),
      "h+": t.getHours(),
      "i+": t.getMinutes(),
      "s+": t.getSeconds(),
      "f+": t.getMilliseconds(),
      "q+": Math.floor((t.getMonth() + 3) / 3)
  };
  if (/(y+)/.test(fmt)) {
      fmt = fmt.replace(RegExp.$1, (t.getFullYear() + "").substr(4 - RegExp.$1.length));
  }
  for (var k in o) {
      if (new RegExp("(" + k + ")").test(fmt)) {
          fmt = fmt.replace(RegExp.$1, (RegExp.$1.length == 1) ? (o[k]) : (("00" + o[k]).substr(("" + o[k]).length)));
      }
  }
  return fmt;
}
/**
 * 验证对象是否为空，true为空，false不为空
 * @param {string} data 对象数据
 */
plugins.empty = function(data) {
  if (data === null) { return true; } 
  if (data === undefined) { return true; } 
  if (data.toString() === "null") { return true; }
  if (typeof(data) == "string") {
    return data.replace(/(\{)|(\})/g,"").trim().length < 1;
  }
  var prostr = Object.prototype.toString.call(data).toLowerCase();
  if (typeof(data) == "object" && prostr == "[object array]") {
    return data.length < 1;
  }
  if (typeof(data) == "object" && prostr == "[object object]") {
    return JSON.stringify(data).replace(/(\{)|(\})/g, "").trim().length < 1;
  }
  return false;
};
/**
 * 数据转Url字符串
 * @param {string} data 数据
 */
plugins.toUrlString = function(data) {
  var refData = [];
  if (typeof(data) == "string") {
    if (data.indexOf("{")>-1 && data.lastIndexOf("}")>-1) { data = JSON.parse(data); } else { return data; }
  }
  if (typeof(data) == "object") {
    if (Object.prototype.toString.call(data).toLowerCase() == "[object array]") { data = JSON.parse(JSON.stringify(data)); }
    if (Object.prototype.toString.call(data).toLowerCase() == "[object object]" && !data.length) {
      for (var key in data) { refData.push(key + '=' + encodeURIComponent(data[key])); }
      return refData.join('&');
    }
  }
  return data;
}
/**
 * 生成二维码
 * @param {string} elem 显示容器
 * @param {string} data 二维码数据
 * @param {string} size 宽度大小
 * @param {string} type 类型【image图片,canvas数据】
 */
plugins.Qrcode= function(elem, data, size, type) {
  size = size || 320;
  type = type || 'canvas';
  var main = document.getElementById(elem);
  var icon = "http://"+"wxrp.qianjiangby.com/static/img/favicon.ico"
  if (type=='image') {
    QRCode.toDataURL(data, {margin:0,src:icon}).then(function(url) { main.src=url; main.style.width=size; main.style.height=size; });
  }
  if (type=='canvas') {
    QRCode.toCanvas(main, data, { margin:0, width:size, src:icon }, function (error) { });
  }
};
/**
 * 获取设备信息
 * @return json {uuid:"设备标识",ver:"版本",osys:"系统",equip:"设备",app:"应用"}
 */
plugins.Device = function () {
  var info = { uuid: "", ver: process.env.VERSION, osys: 9, equip: 101, app: 1 };

  var u = navigator.userAgent, p = navigator.platform;
  var isAnd = (!!u.match(/Linux/) && !!u.match(/Android/));
  var isMac = (!!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/) || ["Mac68K","MacPPC","Macintosh","MacIntel"].indexOf(p) >- 1);
  // console.log(u, navigator.platform);
  
  if (isMac) { info.osys = 2; } // 苹果
  else if (isAnd) { info.osys = 4; } // Android
  
  if (!!u.match(/iPad/)) { info.equip = 102; } // pad
  else if (!!u.match(/Mobile/)) { info.equip = 103; } // 手机

  if (!!u.match(/AlipayClient/)) { info.app = 3; } // 支付宝内置
  else if (!!u.match(/MicroMessenger/)) { info.app = 2; } // 微信内置
  else if (isMac && !!u.match(/ QQ/)) { info.app = 4; } // Ios QQ内置
  else if (isAnd && !!u.match(/QQ/) && !!u.match(/MQQBrowser/)) { info.app = 4; } // Android QQ内置
  
  info.uuid = (new Fingerprint({canvas:true}).get());

  return info;
};
/**
 * MD5加密（支持数组，JSON，字符串）
 * @param {String} data 要加密的数据（支持数组，JSON，字符串）
 * @param {Boolean} uper 输出是否大写
 */
plugins.MD5= function(data, uper) {
  if (uper == undefined) { uper = false; }
  var en_string = JSMD5(plugins.toUrlString(data));
  return uper ? en_string.toUpperCase() : en_string;
};
/**
 * MD5签名（支持数组，JSON，字符串）
 * @param {String} d 要签名的数据（支持数组，JSON，字符串）
 * @param {String} k KEY签名
 */
plugins.MD5Sign= function(d, k) {
  var data = plugins.toUrlString(d);
  if (k!=undefined) { data += ("&key=" + k); }
  return JSMD5(data).toUpperCase();
};
/**
 * base64数据加解码
 * @param {String} d 要处理的数据（支持数组，JSON，字符串）
 * @param {String} t 加码解码['en','de']默认en
 */
plugins.Base64= function(d, t) {
  var data = plugins.toUrlString(d);
  if (t === 'de') { return JSBase64.Base64.decode(data); }
  return JSBase64.Base64.encode(data);
};
/**
 * 获取URL地址请求参数值
 * @param {string} name 参数KEY
 */
plugins.urlQuery= function(name) {
  var regesp = new RegExp("(^|&)" + name + "=([^&]*)(&|$)");
  var result = window.location.search.substr(1).match(regesp);
  if (result != null) { return unescape(result[2]); }
  return '';
};

export default plugins;


// WEBPACK FOOTER //
// ./src/assets/js/plugins.js